import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      static w2g(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.d2g_1 = level;
        $this.e2g_1 = marker;
        $this.f2g_1 = loggerName;
        $this.g2g_1 = message;
        $this.h2g_1 = cause;
        $this.i2g_1 = payload;
        $this.j2g_1 = timestamp;
        return $this;
      }
      static x2g(level, marker, loggerName, eventBuilder) {
        return this.w2g(level, marker, loggerName, eventBuilder.o2g_1, eventBuilder.p2g_1, eventBuilder.q2g_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.d2g_1.toString() + ', marker=' + toString(this.e2g_1) + ', loggerName=' + this.f2g_1 + ', message=' + this.g2g_1 + ', cause=' + toString(this.h2g_1) + ', payload=' + toString(this.i2g_1) + ', timestamp=' + this.j2g_1.toString() + ')';
      }
      hashCode() {
        var result = this.d2g_1.hashCode();
        result = imul(result, 31) + (this.e2g_1 == null ? 0 : hashCode(this.e2g_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.f2g_1) | 0;
        result = imul(result, 31) + (this.g2g_1 == null ? 0 : getStringHashCode(this.g2g_1)) | 0;
        result = imul(result, 31) + (this.h2g_1 == null ? 0 : hashCode(this.h2g_1)) | 0;
        result = imul(result, 31) + (this.i2g_1 == null ? 0 : hashCode(this.i2g_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.j2g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.d2g_1.equals(tmp0_other_with_cast.d2g_1))
          return false;
        if (!equals(this.e2g_1, tmp0_other_with_cast.e2g_1))
          return false;
        if (!(this.f2g_1 === tmp0_other_with_cast.f2g_1))
          return false;
        if (!(this.g2g_1 == tmp0_other_with_cast.g2g_1))
          return false;
        if (!equals(this.h2g_1, tmp0_other_with_cast.h2g_1))
          return false;
        if (!equals(this.i2g_1, tmp0_other_with_cast.i2g_1))
          return false;
        if (!(this.j2g_1 === tmp0_other_with_cast.j2g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
